/*
 * WARNING: THIS IS A SELF GENERATED FILE, DO NOT ADD NEW ICONS HERE
 */
/* eslint-disable prettier/prettier */
import React, { lazy,LazyExoticComponent, ReactElement } from 'react';

import { Glyphs } from './generated.types';
import { Skeleton } from './Glyph';

export const GlyphMap: {
  [K in keyof Glyphs]: {
    [P in Glyphs[K]]: LazyExoticComponent<() => ReactElement>;
  };
} = {
	'Alerts': {
		'HelpCircle': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Alerts/IconHelpCircle`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon HelpCircle from category Alerts`);
        return { default: () => <Skeleton /> };
      })
    ),
		'HelpPopup': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Alerts/IconHelpPopup`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon HelpPopup from category Alerts`);
        return { default: () => <Skeleton /> };
      })
    ),
		'HelpQuery': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Alerts/IconHelpQuery`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon HelpQuery from category Alerts`);
        return { default: () => <Skeleton /> };
      })
    ),
		'HelpSquare': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Alerts/IconHelpSquare`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon HelpSquare from category Alerts`);
        return { default: () => <Skeleton /> };
      })
    ),
		'InfoCircle': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Alerts/IconInfoCircle`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon InfoCircle from category Alerts`);
        return { default: () => <Skeleton /> };
      })
    ),
		'InfoCircleOutline': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Alerts/IconInfoCircleOutline`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon InfoCircleOutline from category Alerts`);
        return { default: () => <Skeleton /> };
      })
    ),
		'InfoManual': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Alerts/IconInfoManual`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon InfoManual from category Alerts`);
        return { default: () => <Skeleton /> };
      })
    ),
		'InfoPopup': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Alerts/IconInfoPopup`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon InfoPopup from category Alerts`);
        return { default: () => <Skeleton /> };
      })
    ),
		'InfoPrivacy': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Alerts/IconInfoPrivacy`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon InfoPrivacy from category Alerts`);
        return { default: () => <Skeleton /> };
      })
    ),
		'InfoSquare': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Alerts/IconInfoSquare`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon InfoSquare from category Alerts`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Notification': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Alerts/IconNotification`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Notification from category Alerts`);
        return { default: () => <Skeleton /> };
      })
    ),
		'NotificationOff': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Alerts/IconNotificationOff`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon NotificationOff from category Alerts`);
        return { default: () => <Skeleton /> };
      })
    ),
		'NotificationOn': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Alerts/IconNotificationOn`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon NotificationOn from category Alerts`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Support': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Alerts/IconSupport`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Support from category Alerts`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Warning': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Alerts/IconWarning`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Warning from category Alerts`);
        return { default: () => <Skeleton /> };
      })
    ),
		'WarningCircle': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Alerts/IconWarningCircle`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon WarningCircle from category Alerts`);
        return { default: () => <Skeleton /> };
      })
    ),
		'WarningGearbox': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Alerts/IconWarningGearbox`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon WarningGearbox from category Alerts`);
        return { default: () => <Skeleton /> };
      })
    ),
		'WarningHighPriority': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Alerts/IconWarningHighPriority`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon WarningHighPriority from category Alerts`);
        return { default: () => <Skeleton /> };
      })
    ),
		'WarningNew': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Alerts/IconWarningNew`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon WarningNew from category Alerts`);
        return { default: () => <Skeleton /> };
      })
    ),
		'WarningOff': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Alerts/IconWarningOff`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon WarningOff from category Alerts`);
        return { default: () => <Skeleton /> };
      })
    ),
		'WarningShield': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Alerts/IconWarningShield`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon WarningShield from category Alerts`);
        return { default: () => <Skeleton /> };
      })
    ),
		'WarningSpam': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Alerts/IconWarningSpam`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon WarningSpam from category Alerts`);
        return { default: () => <Skeleton /> };
      })
    ),
	},
	'Amenities': {
		'AirConditioning': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Amenities/IconAirConditioning`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon AirConditioning from category Amenities`);
        return { default: () => <Skeleton /> };
      })
    ),
		'BedBunk': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Amenities/IconBedBunk`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon BedBunk from category Amenities`);
        return { default: () => <Skeleton /> };
      })
    ),
		'BedDouble': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Amenities/IconBedDouble`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon BedDouble from category Amenities`);
        return { default: () => <Skeleton /> };
      })
    ),
		'BedSingle': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Amenities/IconBedSingle`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon BedSingle from category Amenities`);
        return { default: () => <Skeleton /> };
      })
    ),
		'BedSleeping': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Amenities/IconBedSleeping`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon BedSleeping from category Amenities`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CoffeeMaker': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Amenities/IconCoffeeMaker`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CoffeeMaker from category Amenities`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Delivery': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Amenities/IconDelivery`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Delivery from category Amenities`);
        return { default: () => <Skeleton /> };
      })
    ),
		'DoNotDisturb': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Amenities/IconDoNotDisturb`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon DoNotDisturb from category Amenities`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Elevator': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Amenities/IconElevator`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Elevator from category Amenities`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Entertainment': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Amenities/IconEntertainment`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Entertainment from category Amenities`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Fireplace': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Amenities/IconFireplace`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Fireplace from category Amenities`);
        return { default: () => <Skeleton /> };
      })
    ),
		'FoodTruck': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Amenities/IconFoodTruck`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon FoodTruck from category Amenities`);
        return { default: () => <Skeleton /> };
      })
    ),
		'HotTub': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Amenities/IconHotTub`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon HotTub from category Amenities`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Iron': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Amenities/IconIron`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Iron from category Amenities`);
        return { default: () => <Skeleton /> };
      })
    ),
		'LightningBolt': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Amenities/IconLightningBolt`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon LightningBolt from category Amenities`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MedicalAssistance': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Amenities/IconMedicalAssistance`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MedicalAssistance from category Amenities`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MedicalServices': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Amenities/IconMedicalServices`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MedicalServices from category Amenities`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Microwave': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Amenities/IconMicrowave`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Microwave from category Amenities`);
        return { default: () => <Skeleton /> };
      })
    ),
		'OutdoorGrill': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Amenities/IconOutdoorGrill`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon OutdoorGrill from category Amenities`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Outlet': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Amenities/IconOutlet`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Outlet from category Amenities`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Parking': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Amenities/IconParking`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Parking from category Amenities`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Pets': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Amenities/IconPets`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Pets from category Amenities`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Power': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Amenities/IconPower`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Power from category Amenities`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Restaurant': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Amenities/IconRestaurant`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Restaurant from category Amenities`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Roadblock': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Amenities/IconRoadblock`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Roadblock from category Amenities`);
        return { default: () => <Skeleton /> };
      })
    ),
		'RoomService': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Amenities/IconRoomService`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon RoomService from category Amenities`);
        return { default: () => <Skeleton /> };
      })
    ),
		'RoomSize': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Amenities/IconRoomSize`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon RoomSize from category Amenities`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Sanitizer': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Amenities/IconSanitizer`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Sanitizer from category Amenities`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Shower': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Amenities/IconShower`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Shower from category Amenities`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Smoke': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Amenities/IconSmoke`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Smoke from category Amenities`);
        return { default: () => <Skeleton /> };
      })
    ),
		'SmokeNo': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Amenities/IconSmokeNo`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon SmokeNo from category Amenities`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Stairs': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Amenities/IconStairs`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Stairs from category Amenities`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Valet': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Amenities/IconValet`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Valet from category Amenities`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Wifi': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Amenities/IconWifi`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Wifi from category Amenities`);
        return { default: () => <Skeleton /> };
      })
    ),
	},
	'Animals': {
		'Bird': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Animals/IconBird`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Bird from category Animals`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Bug': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Animals/IconBug`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Bug from category Animals`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Cat': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Animals/IconCat`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Cat from category Animals`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Dog': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Animals/IconDog`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Dog from category Animals`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Farm': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Animals/IconFarm`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Farm from category Animals`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Sea': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Animals/IconSea`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Sea from category Animals`);
        return { default: () => <Skeleton /> };
      })
    ),
	},
	'Arrows': {
		'ChevronDoubleLeft': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Arrows/IconChevronDoubleLeft`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ChevronDoubleLeft from category Arrows`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ChevronDoubleRight': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Arrows/IconChevronDoubleRight`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ChevronDoubleRight from category Arrows`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ChevronDown': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Arrows/IconChevronDown`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ChevronDown from category Arrows`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ChevronLeft': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Arrows/IconChevronLeft`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ChevronLeft from category Arrows`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ChevronRight': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Arrows/IconChevronRight`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ChevronRight from category Arrows`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ChevronUp': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Arrows/IconChevronUp`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ChevronUp from category Arrows`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CircledDown': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Arrows/IconCircledDown`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CircledDown from category Arrows`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CircledLeft': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Arrows/IconCircledLeft`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CircledLeft from category Arrows`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CircledLeftDown': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Arrows/IconCircledLeftDown`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CircledLeftDown from category Arrows`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CircledRight': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Arrows/IconCircledRight`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CircledRight from category Arrows`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CircledRightDown': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Arrows/IconCircledRightDown`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CircledRightDown from category Arrows`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CircledRightUp': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Arrows/IconCircledRightUp`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CircledRightUp from category Arrows`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CircledUp': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Arrows/IconCircledUp`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CircledUp from category Arrows`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Double': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Arrows/IconDouble`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Double from category Arrows`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Down': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Arrows/IconDown`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Down from category Arrows`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Left': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Arrows/IconLeft`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Left from category Arrows`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Left1StPage': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Arrows/IconLeft1StPage`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Left1StPage from category Arrows`);
        return { default: () => <Skeleton /> };
      })
    ),
		'LeftUp': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Arrows/IconLeftUp`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon LeftUp from category Arrows`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Opposites': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Arrows/IconOpposites`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Opposites from category Arrows`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Process': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Arrows/IconProcess`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Process from category Arrows`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Refresh': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Arrows/IconRefresh`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Refresh from category Arrows`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Reset': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Arrows/IconReset`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Reset from category Arrows`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Right': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Arrows/IconRight`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Right from category Arrows`);
        return { default: () => <Skeleton /> };
      })
    ),
		'RightLastPage': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Arrows/IconRightLastPage`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon RightLastPage from category Arrows`);
        return { default: () => <Skeleton /> };
      })
    ),
		'SwapHorizontal': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Arrows/IconSwapHorizontal`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon SwapHorizontal from category Arrows`);
        return { default: () => <Skeleton /> };
      })
    ),
		'SwapVertical': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Arrows/IconSwapVertical`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon SwapVertical from category Arrows`);
        return { default: () => <Skeleton /> };
      })
    ),
		'SwapVerticalApplied': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Arrows/IconSwapVerticalApplied`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon SwapVerticalApplied from category Arrows`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Up': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Arrows/IconUp`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Up from category Arrows`);
        return { default: () => <Skeleton /> };
      })
    ),
	},
	'Baggage': {
		'Backpack': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Baggage/IconBackpack`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Backpack from category Baggage`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Baggage': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Baggage/IconBaggage`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Baggage from category Baggage`);
        return { default: () => <Skeleton /> };
      })
    ),
		'BaggageNotIncluded': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Baggage/IconBaggageNotIncluded`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon BaggageNotIncluded from category Baggage`);
        return { default: () => <Skeleton /> };
      })
    ),
		'BaggageSmall': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Baggage/IconBaggageSmall`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon BaggageSmall from category Baggage`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Briefcase': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Baggage/IconBriefcase`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Briefcase from category Baggage`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CheckinBaggage': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Baggage/IconCheckinBaggage`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CheckinBaggage from category Baggage`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Delay': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Baggage/IconDelay`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Delay from category Baggage`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Large': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Baggage/IconLarge`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Large from category Baggage`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Medium': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Baggage/IconMedium`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Medium from category Baggage`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Wallet': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Baggage/IconWallet`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Wallet from category Baggage`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Weight': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Baggage/IconWeight`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Weight from category Baggage`);
        return { default: () => <Skeleton /> };
      })
    ),
	},
	'Communication': {
		'Chat': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconChat`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Chat from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ChatDesktop': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconChatDesktop`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ChatDesktop from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ChatDiscussion': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconChatDiscussion`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ChatDiscussion from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ChatNo': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconChatNo`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ChatNo from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ChatRoom': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconChatRoom`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ChatRoom from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'HelpQuestion': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconHelpQuestion`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon HelpQuestion from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Inbox': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconInbox`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Inbox from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'InboxAdd': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconInboxAdd`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon InboxAdd from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'InboxCheck': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconInboxCheck`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon InboxCheck from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'InboxRemove': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconInboxRemove`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon InboxRemove from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'InboxSettings': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconInboxSettings`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon InboxSettings from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Mail': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconMail`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Mail from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MailAddress': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconMailAddress`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MailAddress from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MailDelete': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconMailDelete`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MailDelete from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MailError': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconMailError`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MailError from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Mailnew': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconMailnew`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Mailnew from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MailOpen': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconMailOpen`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MailOpen from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MailRefresh': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconMailRefresh`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MailRefresh from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MailSearch': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconMailSearch`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MailSearch from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MailSecure': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconMailSecure`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MailSecure from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MailSent': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconMailSent`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MailSent from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MailUnread': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconMailUnread`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MailUnread from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MailUnsubscribe': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconMailUnsubscribe`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MailUnsubscribe from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MailUrgent': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconMailUrgent`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MailUrgent from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MailWrite': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconMailWrite`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MailWrite from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MessageBlocked': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconMessageBlocked`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MessageBlocked from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MessageContact': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconMessageContact`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MessageContact from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MessageDelete': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconMessageDelete`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MessageDelete from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MessageHelp': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconMessageHelp`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MessageHelp from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MessageHighlight': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconMessageHighlight`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MessageHighlight from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MessagePoll': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconMessagePoll`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MessagePoll from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MessagePriority': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconMessagePriority`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MessagePriority from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MessageQuestion': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconMessageQuestion`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MessageQuestion from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MessageQuote': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconMessageQuote`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MessageQuote from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MessageSearch': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconMessageSearch`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MessageSearch from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MessageSent': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconMessageSent`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MessageSent from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MessageSettings': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconMessageSettings`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MessageSettings from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MessageTyping': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconMessageTyping`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MessageTyping from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MessageUser': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconMessageUser`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MessageUser from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MessageVideo': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconMessageVideo`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MessageVideo from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Phone': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconPhone`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Phone from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'PhoneAdd': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconPhoneAdd`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon PhoneAdd from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'PhoneDisconnected': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconPhoneDisconnected`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon PhoneDisconnected from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'PhoneHotline': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconPhoneHotline`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon PhoneHotline from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Phoneincoming': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconPhoneincoming`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Phoneincoming from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'PhoneNot': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconPhoneNot`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon PhoneNot from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'PhoneOutgoing': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconPhoneOutgoing`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon PhoneOutgoing from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'PhoneReply': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconPhoneReply`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon PhoneReply from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'PhoneWaves': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconPhoneWaves`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon PhoneWaves from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'RateReview': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconRateReview`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon RateReview from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Sms': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconSms`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Sms from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'SpeakerNotes': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconSpeakerNotes`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon SpeakerNotes from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'SpeakerNotesOff': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconSpeakerNotesOff`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon SpeakerNotesOff from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Warningannouncement': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Communication/IconWarningannouncement`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Warningannouncement from category Communication`);
        return { default: () => <Skeleton /> };
      })
    ),
	},
	'Content': {
		'AirlineStops': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconAirlineStops`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon AirlineStops from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Article': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconArticle`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Article from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Asterisk': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconAsterisk`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Asterisk from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'AsteriskSquare': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconAsteriskSquare`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon AsteriskSquare from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'AutoFix': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconAutoFix`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon AutoFix from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Bookmark': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconBookmark`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Bookmark from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'BookmarkAdd': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconBookmarkAdd`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon BookmarkAdd from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'BookmarkAdded': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconBookmarkAdded`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon BookmarkAdded from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'BookmarkBook': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconBookmarkBook`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon BookmarkBook from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'BookmarkOutline': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconBookmarkOutline`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon BookmarkOutline from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'BookmarkRemove': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconBookmarkRemove`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon BookmarkRemove from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Bookmarks': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconBookmarks`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Bookmarks from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ContactDetails': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconContactDetails`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ContactDetails from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Crown': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconCrown`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Crown from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Directions': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconDirections`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Directions from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Document': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconDocument`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Document from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'DocumentCheck': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconDocumentCheck`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon DocumentCheck from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'DocumentDelete': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconDocumentDelete`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon DocumentDelete from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'DocumentFavorite': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconDocumentFavorite`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon DocumentFavorite from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'DocumentImportant': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconDocumentImportant`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon DocumentImportant from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'DocumentLink': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconDocumentLink`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon DocumentLink from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'DocumentPdf': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconDocumentPdf`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon DocumentPdf from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'DocumentPreview': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconDocumentPreview`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon DocumentPreview from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'DocumentPrivacyPolice': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconDocumentPrivacyPolice`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon DocumentPrivacyPolice from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'DocumentSara': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconDocumentSara`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon DocumentSara from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'DocumentSearch': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconDocumentSearch`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon DocumentSearch from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'DocumentSettings': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconDocumentSettings`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon DocumentSettings from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'DocumentShield': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconDocumentShield`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon DocumentShield from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'DocumentStatistics': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconDocumentStatistics`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon DocumentStatistics from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'DocumentUser': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconDocumentUser`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon DocumentUser from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'DoNotDisturb': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconDoNotDisturb`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon DoNotDisturb from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Downloads': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconDownloads`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Downloads from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Flag': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconFlag`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Flag from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'FlagOutline': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconFlagOutline`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon FlagOutline from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Folder': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconFolder`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Folder from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'FolderAdd': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconFolderAdd`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon FolderAdd from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'FolderDelete': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconFolderDelete`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon FolderDelete from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'FolderEdit': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconFolderEdit`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon FolderEdit from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'FolderLock': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconFolderLock`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon FolderLock from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'FolderSearch': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconFolderSearch`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon FolderSearch from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'FolderSettings': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconFolderSettings`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon FolderSettings from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Language': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconLanguage`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Language from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Link': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconLink`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Link from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'LinkExternal': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconLinkExternal`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon LinkExternal from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ListBullets': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconListBullets`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ListBullets from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ListFeatures': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconListFeatures`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ListFeatures from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ListGrid': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconListGrid`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ListGrid from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ListNumbered': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconListNumbered`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ListNumbered from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ListQuestionnaire': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconListQuestionnaire`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ListQuestionnaire from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ListSingleChoice': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconListSingleChoice`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ListSingleChoice from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ListTableOfContent': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconListTableOfContent`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ListTableOfContent from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ListTasks': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconListTasks`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ListTasks from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ListTodo': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconListTodo`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ListTodo from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ListWishlist': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconListWishlist`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ListWishlist from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Location': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconLocation`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Location from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'LocationNotListed': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconLocationNotListed`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon LocationNotListed from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Map': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconMap`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Map from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Navigation': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconNavigation`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Navigation from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Password': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconPassword`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Password from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Public': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconPublic`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Public from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Route': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconRoute`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Route from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Signature': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconSignature`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Signature from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'StarMultiple': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconStarMultiple`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon StarMultiple from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'StarSquare': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconStarSquare`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon StarSquare from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Verified': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconVerified`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Verified from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ViewTable': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Content/IconViewTable`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ViewTable from category Content`);
        return { default: () => <Skeleton /> };
      })
    ),
	},
	'Deals': {
		'CashHands': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Deals/IconCashHands`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CashHands from category Deals`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Cheap': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Deals/IconCheap`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Cheap from category Deals`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CheckDeal': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Deals/IconCheckDeal`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CheckDeal from category Deals`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Coupon': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Deals/IconCoupon`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Coupon from category Deals`);
        return { default: () => <Skeleton /> };
      })
    ),
		'DiscountFinder': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Deals/IconDiscountFinder`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon DiscountFinder from category Deals`);
        return { default: () => <Skeleton /> };
      })
    ),
		'DoorHandle': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Deals/IconDoorHandle`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon DoorHandle from category Deals`);
        return { default: () => <Skeleton /> };
      })
    ),
		'DutyFree': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Deals/IconDutyFree`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon DutyFree from category Deals`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Gift': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Deals/IconGift`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Gift from category Deals`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Hot': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Deals/IconHot`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Hot from category Deals`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Leaf': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Deals/IconLeaf`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Leaf from category Deals`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Lightning': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Deals/IconLightning`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Lightning from category Deals`);
        return { default: () => <Skeleton /> };
      })
    ),
		'LightningBolt': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Deals/IconLightningBolt`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon LightningBolt from category Deals`);
        return { default: () => <Skeleton /> };
      })
    ),
		'LowPrice': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Deals/IconLowPrice`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon LowPrice from category Deals`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Percentage': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Deals/IconPercentage`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Percentage from category Deals`);
        return { default: () => <Skeleton /> };
      })
    ),
		'PercentageCard': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Deals/IconPercentageCard`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon PercentageCard from category Deals`);
        return { default: () => <Skeleton /> };
      })
    ),
		'PercentageDiscount': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Deals/IconPercentageDiscount`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon PercentageDiscount from category Deals`);
        return { default: () => <Skeleton /> };
      })
    ),
		'PriceFreeze': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Deals/IconPriceFreeze`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon PriceFreeze from category Deals`);
        return { default: () => <Skeleton /> };
      })
    ),
		'PrivateSale': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Deals/IconPrivateSale`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon PrivateSale from category Deals`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Sale': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Deals/IconSale`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Sale from category Deals`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Savings': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Deals/IconSavings`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Savings from category Deals`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ShoopingCartBuy': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Deals/IconShoopingCartBuy`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ShoopingCartBuy from category Deals`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ShoopingCartFavorite': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Deals/IconShoopingCartFavorite`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ShoopingCartFavorite from category Deals`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ShoppingBag': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Deals/IconShoppingBag`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ShoppingBag from category Deals`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ShoppingBasket': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Deals/IconShoppingBasket`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ShoppingBasket from category Deals`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ShoppingCart': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Deals/IconShoppingCart`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ShoppingCart from category Deals`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Tag': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Deals/IconTag`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Tag from category Deals`);
        return { default: () => <Skeleton /> };
      })
    ),
		'TagDiscount': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Deals/IconTagDiscount`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon TagDiscount from category Deals`);
        return { default: () => <Skeleton /> };
      })
    ),
		'TagMoney': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Deals/IconTagMoney`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon TagMoney from category Deals`);
        return { default: () => <Skeleton /> };
      })
    ),
		'TagMultiple': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Deals/IconTagMultiple`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon TagMultiple from category Deals`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Target': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Deals/IconTarget`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Target from category Deals`);
        return { default: () => <Skeleton /> };
      })
    ),
		'TopRated': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Deals/IconTopRated`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon TopRated from category Deals`);
        return { default: () => <Skeleton /> };
      })
    ),
		'TopSaver': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Deals/IconTopSaver`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon TopSaver from category Deals`);
        return { default: () => <Skeleton /> };
      })
    ),
		'TrendingDown': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Deals/IconTrendingDown`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon TrendingDown from category Deals`);
        return { default: () => <Skeleton /> };
      })
    ),
		'TrendingUp': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Deals/IconTrendingUp`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon TrendingUp from category Deals`);
        return { default: () => <Skeleton /> };
      })
    ),
	},
	'Devices': {
		'BatteryCharging': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconBatteryCharging`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon BatteryCharging from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'BatteryEmpty': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconBatteryEmpty`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon BatteryEmpty from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'BatteryLevel': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconBatteryLevel`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon BatteryLevel from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'BatteryNo': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconBatteryNo`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon BatteryNo from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Bluetooth': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconBluetooth`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Bluetooth from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'BluetoothConnected': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconBluetoothConnected`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon BluetoothConnected from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'BluetoothDisable': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconBluetoothDisable`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon BluetoothDisable from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'BluetoothSymbol': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconBluetoothSymbol`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon BluetoothSymbol from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Cloud': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconCloud`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Cloud from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CloudDelete': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconCloudDelete`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CloudDelete from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CloudError': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconCloudError`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CloudError from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CloudOff': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconCloudOff`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CloudOff from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CloudRefresh': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconCloudRefresh`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CloudRefresh from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CloudSearch': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconCloudSearch`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CloudSearch from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CloudSecure': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconCloudSecure`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CloudSecure from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CloudWaiting': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconCloudWaiting`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CloudWaiting from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ConnectionLow': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconConnectionLow`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ConnectionLow from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ConnectionNo': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconConnectionNo`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ConnectionNo from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ConnectionSignal': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconConnectionSignal`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ConnectionSignal from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Contactless': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconContactless`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Contactless from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Desktop': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconDesktop`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Desktop from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Devices': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconDevices`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Devices from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'DevicesAndroid': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconDevicesAndroid`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon DevicesAndroid from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'DevicesApplewatch': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconDevicesApplewatch`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon DevicesApplewatch from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'DevicesHeadset': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconDevicesHeadset`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon DevicesHeadset from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'DevicesIpad': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconDevicesIpad`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon DevicesIpad from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'DevicesIphone': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconDevicesIphone`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon DevicesIphone from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'DevicesMultiple': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconDevicesMultiple`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon DevicesMultiple from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'GesturePinch': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconGesturePinch`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon GesturePinch from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'GestureSwipe': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconGestureSwipe`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon GestureSwipe from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'GestureSwipeDown': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconGestureSwipeDown`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon GestureSwipeDown from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'GestureSwipeLeft': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconGestureSwipeLeft`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon GestureSwipeLeft from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'GestureSwipeRight': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconGestureSwipeRight`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon GestureSwipeRight from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'GestureSwipeUp': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconGestureSwipeUp`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon GestureSwipeUp from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'GestureTouch': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconGestureTouch`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon GestureTouch from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'GpsFixed': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconGpsFixed`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon GpsFixed from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'GpsNotFixed': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconGpsNotFixed`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon GpsNotFixed from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'GpsOff': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconGpsOff`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon GpsOff from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Headphones': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconHeadphones`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Headphones from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Internet': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconInternet`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Internet from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Keyboard': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconKeyboard`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Keyboard from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'KeyboardHide': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconKeyboardHide`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon KeyboardHide from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Laptop': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconLaptop`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Laptop from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Mouse': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconMouse`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Mouse from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Router': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconRouter`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Router from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'SmartphoneApprove': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconSmartphoneApprove`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon SmartphoneApprove from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'SmartphoneDecline': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconSmartphoneDecline`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon SmartphoneDecline from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'SmartphoneInfo': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconSmartphoneInfo`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon SmartphoneInfo from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'SmartphoneLock': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconSmartphoneLock`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon SmartphoneLock from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'SystemUpdate': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconSystemUpdate`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon SystemUpdate from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Tv': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconTv`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Tv from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Usb': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconUsb`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Usb from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Wifi': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconWifi`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Wifi from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'WifiLimited': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconWifiLimited`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon WifiLimited from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'WifiLock': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconWifiLock`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon WifiLock from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'WifiNo': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconWifiNo`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon WifiNo from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'WifiOff': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconWifiOff`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon WifiOff from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'WifiOn': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconWifiOn`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon WifiOn from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
		'WifiPassword': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Devices/IconWifiPassword`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon WifiPassword from category Devices`);
        return { default: () => <Skeleton /> };
      })
    ),
	},
	'Finances': {
		'AdsClick': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconAdsClick`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon AdsClick from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Balance': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconBalance`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Balance from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
		'BankTransfer': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconBankTransfer`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon BankTransfer from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Calculate': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconCalculate`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Calculate from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Card': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconCard`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Card from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CardCvv': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconCardCvv`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CardCvv from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CardNotAccepted': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconCardNotAccepted`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CardNotAccepted from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CardPayment': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconCardPayment`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CardPayment from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Cards': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconCards`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Cards from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CardSecurity': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconCardSecurity`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CardSecurity from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Chart': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconChart`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Chart from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ChartArea': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconChartArea`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ChartArea from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ChartBars': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconChartBars`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ChartBars from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ChartDecline': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconChartDecline`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ChartDecline from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ChartFlow': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconChartFlow`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ChartFlow from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ChartFutures': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconChartFutures`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ChartFutures from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ChartPie': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconChartPie`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ChartPie from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ChartPresentation': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconChartPresentation`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ChartPresentation from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Coins': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconCoins`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Coins from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CurrecyExchange': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconCurrecyExchange`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CurrecyExchange from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Debt': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconDebt`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Debt from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Invoice': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconInvoice`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Invoice from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Money': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconMoney`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Money from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MoneyBag': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconMoneyBag`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MoneyBag from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MoneyBox': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconMoneyBox`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MoneyBox from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MoneyOk': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconMoneyOk`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MoneyOk from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MoneySecure': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconMoneySecure`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MoneySecure from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MoneyStack': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconMoneyStack`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MoneyStack from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
		'NoRefundable': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconNoRefundable`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon NoRefundable from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
		'PaidBill': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconPaidBill`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon PaidBill from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
		'PartiallyRefundable': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconPartiallyRefundable`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon PartiallyRefundable from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
		'PaymentCheck': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconPaymentCheck`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon PaymentCheck from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
		'PaymentHistory': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconPaymentHistory`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon PaymentHistory from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
		'QrCode': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconQrCode`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon QrCode from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Receipt': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconReceipt`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Receipt from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ReceiveCash': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconReceiveCash`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ReceiveCash from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Tax': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconTax`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Tax from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
		'TransactionApproved': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconTransactionApproved`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon TransactionApproved from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
		'TransactionDeclined': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Finances/IconTransactionDeclined`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon TransactionDeclined from category Finances`);
        return { default: () => <Skeleton /> };
      })
    ),
	},
	'Food': {
		'AllInclusive': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Food/IconAllInclusive`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon AllInclusive from category Food`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Barbacue': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Food/IconBarbacue`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Barbacue from category Food`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Bread': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Food/IconBread`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Bread from category Food`);
        return { default: () => <Skeleton /> };
      })
    ),
		'BreakfastIncluded': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Food/IconBreakfastIncluded`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon BreakfastIncluded from category Food`);
        return { default: () => <Skeleton /> };
      })
    ),
		'BreakfastNotIncluded': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Food/IconBreakfastNotIncluded`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon BreakfastNotIncluded from category Food`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Burger': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Food/IconBurger`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Burger from category Food`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Cake': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Food/IconCake`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Cake from category Food`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Candies': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Food/IconCandies`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Candies from category Food`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Cookie': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Food/IconCookie`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Cookie from category Food`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Croissant': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Food/IconCroissant`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Croissant from category Food`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Cupcake': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Food/IconCupcake`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Cupcake from category Food`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Donut': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Food/IconDonut`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Donut from category Food`);
        return { default: () => <Skeleton /> };
      })
    ),
		'FastFood': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Food/IconFastFood`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon FastFood from category Food`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Fries': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Food/IconFries`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Fries from category Food`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Fruits': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Food/IconFruits`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Fruits from category Food`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Grapes': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Food/IconGrapes`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Grapes from category Food`);
        return { default: () => <Skeleton /> };
      })
    ),
		'HotDog': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Food/IconHotDog`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon HotDog from category Food`);
        return { default: () => <Skeleton /> };
      })
    ),
		'IceCream': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Food/IconIceCream`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon IceCream from category Food`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Natural': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Food/IconNatural`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Natural from category Food`);
        return { default: () => <Skeleton /> };
      })
    ),
		'NoDairy': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Food/IconNoDairy`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon NoDairy from category Food`);
        return { default: () => <Skeleton /> };
      })
    ),
		'NoGluten': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Food/IconNoGluten`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon NoGluten from category Food`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Noodles': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Food/IconNoodles`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Noodles from category Food`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Pizza': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Food/IconPizza`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Pizza from category Food`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Seafood': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Food/IconSeafood`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Seafood from category Food`);
        return { default: () => <Skeleton /> };
      })
    ),
		'SelfCatering': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Food/IconSelfCatering`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon SelfCatering from category Food`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Sushi': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Food/IconSushi`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Sushi from category Food`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Vegan': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Food/IconVegan`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Vegan from category Food`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Vegetables': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Food/IconVegetables`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Vegetables from category Food`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Vegetarian': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Food/IconVegetarian`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Vegetarian from category Food`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Watermelon': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Food/IconWatermelon`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Watermelon from category Food`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Wine': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Food/IconWine`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Wine from category Food`);
        return { default: () => <Skeleton /> };
      })
    ),
	},
	'Media': {
		'4K': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Media/Icon4K`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon 4K from category Media`);
        return { default: () => <Skeleton /> };
      })
    ),
		'AddQueue': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Media/IconAddQueue`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon AddQueue from category Media`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Airplay': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Media/IconAirplay`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Airplay from category Media`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Camera': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Media/IconCamera`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Camera from category Media`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Forward': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Media/IconForward`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Forward from category Media`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Hd': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Media/IconHd`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Hd from category Media`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Mic': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Media/IconMic`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Mic from category Media`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MicBlock': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Media/IconMicBlock`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MicBlock from category Media`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MicSettings': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Media/IconMicSettings`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MicSettings from category Media`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Movie': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Media/IconMovie`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Movie from category Media`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Mute': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Media/IconMute`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Mute from category Media`);
        return { default: () => <Skeleton /> };
      })
    ),
		'NoSound': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Media/IconNoSound`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon NoSound from category Media`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Pause': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Media/IconPause`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Pause from category Media`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Photos': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Media/IconPhotos`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Photos from category Media`);
        return { default: () => <Skeleton /> };
      })
    ),
		'PhotosAlbums': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Media/IconPhotosAlbums`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon PhotosAlbums from category Media`);
        return { default: () => <Skeleton /> };
      })
    ),
		'PhotosBroken': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Media/IconPhotosBroken`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon PhotosBroken from category Media`);
        return { default: () => <Skeleton /> };
      })
    ),
		'PhotosGallery': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Media/IconPhotosGallery`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon PhotosGallery from category Media`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Play': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Media/IconPlay`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Play from category Media`);
        return { default: () => <Skeleton /> };
      })
    ),
		'PlayCircle': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Media/IconPlayCircle`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon PlayCircle from category Media`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Podcast': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Media/IconPodcast`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Podcast from category Media`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Replay': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Media/IconReplay`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Replay from category Media`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Rewind': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Media/IconRewind`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Rewind from category Media`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Shuffle': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Media/IconShuffle`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Shuffle from category Media`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Sound': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Media/IconSound`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Sound from category Media`);
        return { default: () => <Skeleton /> };
      })
    ),
		'SoundLow': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Media/IconSoundLow`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon SoundLow from category Media`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Stop': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Media/IconStop`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Stop from category Media`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Video': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Media/IconVideo`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Video from category Media`);
        return { default: () => <Skeleton /> };
      })
    ),
		'VideoGallery': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Media/IconVideoGallery`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon VideoGallery from category Media`);
        return { default: () => <Skeleton /> };
      })
    ),
	},
	'Objects': {
		'Bathtub': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Objects/IconBathtub`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Bathtub from category Objects`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Broom': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Objects/IconBroom`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Broom from category Objects`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ClothesHanger': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Objects/IconClothesHanger`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ClothesHanger from category Objects`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Cooker': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Objects/IconCooker`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Cooker from category Objects`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Hairdryer': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Objects/IconHairdryer`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Hairdryer from category Objects`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Knife': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Objects/IconKnife`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Knife from category Objects`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Lightbulb': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Objects/IconLightbulb`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Lightbulb from category Objects`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Microwave': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Objects/IconMicrowave`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Microwave from category Objects`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ObjectSoup': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Objects/IconObjectSoup`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ObjectSoup from category Objects`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Sofa': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Objects/IconSofa`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Sofa from category Objects`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Spatula': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Objects/IconSpatula`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Spatula from category Objects`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Toaster': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Objects/IconToaster`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Toaster from category Objects`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ToiletPaper': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Objects/IconToiletPaper`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ToiletPaper from category Objects`);
        return { default: () => <Skeleton /> };
      })
    ),
	},
	'Places': {
		'Atm': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconAtm`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Atm from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Bar': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconBar`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Bar from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Barbershop': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconBarbershop`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Barbershop from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Beach': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconBeach`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Beach from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'BusinessCenter': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconBusinessCenter`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon BusinessCenter from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Camping': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconCamping`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Camping from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CarRepair': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconCarRepair`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CarRepair from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Casino': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconCasino`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Casino from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Church': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconChurch`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Church from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Cinema': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconCinema`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Cinema from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Circus': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconCircus`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Circus from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'City': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconCity`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon City from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ConvenienceStore': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconConvenienceStore`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ConvenienceStore from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Desk': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconDesk`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Desk from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Emergency': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconEmergency`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Emergency from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Factory': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconFactory`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Factory from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Festival': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconFestival`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Festival from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Forest': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconForest`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Forest from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'GasStation': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconGasStation`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon GasStation from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Golf': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconGolf`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Golf from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Gym': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconGym`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Gym from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Hospital': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconHospital`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Hospital from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Hotel': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconHotel`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Hotel from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'House': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconHouse`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon House from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Landmark': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconLandmark`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Landmark from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Library': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconLibrary`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Library from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'LocalMall': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconLocalMall`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon LocalMall from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Monastery': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconMonastery`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Monastery from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Mosque': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconMosque`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Mosque from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Museum': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconMuseum`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Museum from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Nightlife': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconNightlife`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Nightlife from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Pagoda': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconPagoda`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Pagoda from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Park': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconPark`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Park from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Pharmacy': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconPharmacy`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Pharmacy from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Police': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconPolice`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Police from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Resort': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconResort`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Resort from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Spa': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconSpa`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Spa from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Stadium': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconStadium`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Stadium from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Store': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconStore`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Store from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Synagogue': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconSynagogue`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Synagogue from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Theater': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconTheater`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Theater from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Themepark': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Places/IconThemepark`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Themepark from category Places`);
        return { default: () => <Skeleton /> };
      })
    ),
	},
	'Planes': {
		'Airlines': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Planes/IconAirlines`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Airlines from category Planes`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ConnectingAirports': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Planes/IconConnectingAirports`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ConnectingAirports from category Planes`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Delay': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Planes/IconDelay`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Delay from category Planes`);
        return { default: () => <Skeleton /> };
      })
    ),
		'FlightCancellation': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Planes/IconFlightCancellation`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon FlightCancellation from category Planes`);
        return { default: () => <Skeleton /> };
      })
    ),
		'FlightDiagonal': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Planes/IconFlightDiagonal`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon FlightDiagonal from category Planes`);
        return { default: () => <Skeleton /> };
      })
    ),
		'FlightDisruption': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Planes/IconFlightDisruption`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon FlightDisruption from category Planes`);
        return { default: () => <Skeleton /> };
      })
    ),
		'FlightFront': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Planes/IconFlightFront`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon FlightFront from category Planes`);
        return { default: () => <Skeleton /> };
      })
    ),
		'FlightLeft': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Planes/IconFlightLeft`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon FlightLeft from category Planes`);
        return { default: () => <Skeleton /> };
      })
    ),
		'FlightRight': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Planes/IconFlightRight`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon FlightRight from category Planes`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Going': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Planes/IconGoing`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Going from category Planes`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Landing': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Planes/IconLanding`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Landing from category Planes`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ModeOff': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Planes/IconModeOff`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ModeOff from category Planes`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Returning': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Planes/IconReturning`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Returning from category Planes`);
        return { default: () => <Skeleton /> };
      })
    ),
	},
	'Prime': {
		'Diamond': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Prime/IconDiamond`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Diamond from category Prime`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Rewards': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Prime/IconRewards`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Rewards from category Prime`);
        return { default: () => <Skeleton /> };
      })
    ),
	},
	'Seats': {
		'ExitLeft': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Seats/IconExitLeft`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ExitLeft from category Seats`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ExitLRight': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Seats/IconExitLRight`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ExitLRight from category Seats`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ExtraLegRoom': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Seats/IconExtraLegRoom`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ExtraLegRoom from category Seats`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Seat': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Seats/IconSeat`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Seat from category Seats`);
        return { default: () => <Skeleton /> };
      })
    ),
		'SeatAisle': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Seats/IconSeatAisle`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon SeatAisle from category Seats`);
        return { default: () => <Skeleton /> };
      })
    ),
		'SeatLegend': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Seats/IconSeatLegend`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon SeatLegend from category Seats`);
        return { default: () => <Skeleton /> };
      })
    ),
		'SeatLegroomExtra': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Seats/IconSeatLegroomExtra`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon SeatLegroomExtra from category Seats`);
        return { default: () => <Skeleton /> };
      })
    ),
		'SeatLegroomNormal': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Seats/IconSeatLegroomNormal`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon SeatLegroomNormal from category Seats`);
        return { default: () => <Skeleton /> };
      })
    ),
		'SeatLegroomReduced': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Seats/IconSeatLegroomReduced`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon SeatLegroomReduced from category Seats`);
        return { default: () => <Skeleton /> };
      })
    ),
		'SeatMiddle': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Seats/IconSeatMiddle`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon SeatMiddle from category Seats`);
        return { default: () => <Skeleton /> };
      })
    ),
		'SeatReclineExtra': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Seats/IconSeatReclineExtra`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon SeatReclineExtra from category Seats`);
        return { default: () => <Skeleton /> };
      })
    ),
		'SeatReclineNormal': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Seats/IconSeatReclineNormal`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon SeatReclineNormal from category Seats`);
        return { default: () => <Skeleton /> };
      })
    ),
		'SeatWindow': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Seats/IconSeatWindow`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon SeatWindow from category Seats`);
        return { default: () => <Skeleton /> };
      })
    ),
		'WaitingRoom': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Seats/IconWaitingRoom`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon WaitingRoom from category Seats`);
        return { default: () => <Skeleton /> };
      })
    ),
		'WindowClose': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Seats/IconWindowClose`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon WindowClose from category Seats`);
        return { default: () => <Skeleton /> };
      })
    ),
	},
	'Security': {
		'Key': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Security/IconKey`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Key from category Security`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Locker': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Security/IconLocker`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Locker from category Security`);
        return { default: () => <Skeleton /> };
      })
    ),
		'LockerNoEncryption': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Security/IconLockerNoEncryption`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon LockerNoEncryption from category Security`);
        return { default: () => <Skeleton /> };
      })
    ),
		'LockerOpen': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Security/IconLockerOpen`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon LockerOpen from category Security`);
        return { default: () => <Skeleton /> };
      })
    ),
		'LockerPassword': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Security/IconLockerPassword`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon LockerPassword from category Security`);
        return { default: () => <Skeleton /> };
      })
    ),
		'LockerPrivacy': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Security/IconLockerPrivacy`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon LockerPrivacy from category Security`);
        return { default: () => <Skeleton /> };
      })
    ),
		'NetworkSecure': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Security/IconNetworkSecure`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon NetworkSecure from category Security`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Safe': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Security/IconSafe`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Safe from category Security`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Shield': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Security/IconShield`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Shield from category Security`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ShieldCheck': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Security/IconShieldCheck`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ShieldCheck from category Security`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ShieldInsurance': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Security/IconShieldInsurance`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ShieldInsurance from category Security`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ShieldPolicy': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Security/IconShieldPolicy`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ShieldPolicy from category Security`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ShieldSecurity': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Security/IconShieldSecurity`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ShieldSecurity from category Security`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ShieldUser': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Security/IconShieldUser`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ShieldUser from category Security`);
        return { default: () => <Skeleton /> };
      })
    ),
		'TouchId': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Security/IconTouchId`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon TouchId from category Security`);
        return { default: () => <Skeleton /> };
      })
    ),
	},
	'Sports': {
		'AmericanFootball': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Sports/IconAmericanFootball`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon AmericanFootball from category Sports`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Athletics': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Sports/IconAthletics`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Athletics from category Sports`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Baseball': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Sports/IconBaseball`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Baseball from category Sports`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Basketball': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Sports/IconBasketball`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Basketball from category Sports`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Bike': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Sports/IconBike`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Bike from category Sports`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Bowling': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Sports/IconBowling`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Bowling from category Sports`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Dance': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Sports/IconDance`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Dance from category Sports`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Diving': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Sports/IconDiving`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Diving from category Sports`);
        return { default: () => <Skeleton /> };
      })
    ),
		'F1': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Sports/IconF1`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon F1 from category Sports`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Football': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Sports/IconFootball`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Football from category Sports`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Game': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Sports/IconGame`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Game from category Sports`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Gimnastics': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Sports/IconGimnastics`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Gimnastics from category Sports`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Golf': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Sports/IconGolf`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Golf from category Sports`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Handball': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Sports/IconHandball`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Handball from category Sports`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Hiking': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Sports/IconHiking`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Hiking from category Sports`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Nfl': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Sports/IconNfl`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Nfl from category Sports`);
        return { default: () => <Skeleton /> };
      })
    ),
		'PingPong': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Sports/IconPingPong`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon PingPong from category Sports`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Roller': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Sports/IconRoller`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Roller from category Sports`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Running': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Sports/IconRunning`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Running from category Sports`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Sail': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Sports/IconSail`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Sail from category Sports`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Skate': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Sports/IconSkate`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Skate from category Sports`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Ski': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Sports/IconSki`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Ski from category Sports`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Snowboard': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Sports/IconSnowboard`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Snowboard from category Sports`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Sup': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Sports/IconSup`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Sup from category Sports`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Surf': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Sports/IconSurf`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Surf from category Sports`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Swim': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Sports/IconSwim`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Swim from category Sports`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Tennis': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Sports/IconTennis`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Tennis from category Sports`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Volley': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Sports/IconVolley`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Volley from category Sports`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Weightlifting': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Sports/IconWeightlifting`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Weightlifting from category Sports`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Yoga': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Sports/IconYoga`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Yoga from category Sports`);
        return { default: () => <Skeleton /> };
      })
    ),
	},
	'TimeAndDates': {
		'Alarm': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/TimeAndDates/IconAlarm`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Alarm from category TimeAndDates`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Calendar': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/TimeAndDates/IconCalendar`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Calendar from category TimeAndDates`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CalendarAdd': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/TimeAndDates/IconCalendarAdd`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CalendarAdd from category TimeAndDates`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CalendarCheck': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/TimeAndDates/IconCalendarCheck`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CalendarCheck from category TimeAndDates`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CalendarDayoff': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/TimeAndDates/IconCalendarDayoff`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CalendarDayoff from category TimeAndDates`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CalendarDelete': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/TimeAndDates/IconCalendarDelete`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CalendarDelete from category TimeAndDates`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CalendarEdit': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/TimeAndDates/IconCalendarEdit`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CalendarEdit from category TimeAndDates`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CalendarEvent': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/TimeAndDates/IconCalendarEvent`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CalendarEvent from category TimeAndDates`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CalendarHistoric': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/TimeAndDates/IconCalendarHistoric`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CalendarHistoric from category TimeAndDates`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CalendarImportant': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/TimeAndDates/IconCalendarImportant`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CalendarImportant from category TimeAndDates`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CalendarRange': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/TimeAndDates/IconCalendarRange`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CalendarRange from category TimeAndDates`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CalendarSchedule': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/TimeAndDates/IconCalendarSchedule`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CalendarSchedule from category TimeAndDates`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CalendarView': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/TimeAndDates/IconCalendarView`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CalendarView from category TimeAndDates`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Future': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/TimeAndDates/IconFuture`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Future from category TimeAndDates`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Historic': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/TimeAndDates/IconHistoric`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Historic from category TimeAndDates`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Sandtime': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/TimeAndDates/IconSandtime`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Sandtime from category TimeAndDates`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Stopwatch': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/TimeAndDates/IconStopwatch`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Stopwatch from category TimeAndDates`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Time': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/TimeAndDates/IconTime`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Time from category TimeAndDates`);
        return { default: () => <Skeleton /> };
      })
    ),
		'TimeAdd': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/TimeAndDates/IconTimeAdd`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon TimeAdd from category TimeAndDates`);
        return { default: () => <Skeleton /> };
      })
    ),
		'TimeAlert': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/TimeAndDates/IconTimeAlert`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon TimeAlert from category TimeAndDates`);
        return { default: () => <Skeleton /> };
      })
    ),
		'TimeCheck': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/TimeAndDates/IconTimeCheck`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon TimeCheck from category TimeAndDates`);
        return { default: () => <Skeleton /> };
      })
    ),
		'TimeFast': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/TimeAndDates/IconTimeFast`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon TimeFast from category TimeAndDates`);
        return { default: () => <Skeleton /> };
      })
    ),
		'TimeImportant': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/TimeAndDates/IconTimeImportant`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon TimeImportant from category TimeAndDates`);
        return { default: () => <Skeleton /> };
      })
    ),
		'TimeRemove': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/TimeAndDates/IconTimeRemove`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon TimeRemove from category TimeAndDates`);
        return { default: () => <Skeleton /> };
      })
    ),
		'TimeSettings': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/TimeAndDates/IconTimeSettings`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon TimeSettings from category TimeAndDates`);
        return { default: () => <Skeleton /> };
      })
    ),
		'TimeUser': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/TimeAndDates/IconTimeUser`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon TimeUser from category TimeAndDates`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Timezone': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/TimeAndDates/IconTimezone`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Timezone from category TimeAndDates`);
        return { default: () => <Skeleton /> };
      })
    ),
	},
	'Transport': {
		'Balloon': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Transport/IconBalloon`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Balloon from category Transport`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Bike': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Transport/IconBike`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Bike from category Transport`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Bus': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Transport/IconBus`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Bus from category Transport`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CableCar': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Transport/IconCableCar`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CableCar from category Transport`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Car': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Transport/IconCar`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Car from category Transport`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CarAir': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Transport/IconCarAir`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CarAir from category Transport`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CarAirbag': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Transport/IconCarAirbag`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CarAirbag from category Transport`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CarDoor': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Transport/IconCarDoor`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CarDoor from category Transport`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CarElectric': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Transport/IconCarElectric`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CarElectric from category Transport`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CarFuel': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Transport/IconCarFuel`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CarFuel from category Transport`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CarMaintenance': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Transport/IconCarMaintenance`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CarMaintenance from category Transport`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CarOil': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Transport/IconCarOil`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CarOil from category Transport`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CarSpeedometer': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Transport/IconCarSpeedometer`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CarSpeedometer from category Transport`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CarSteeringWheel': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Transport/IconCarSteeringWheel`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CarSteeringWheel from category Transport`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CarTire': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Transport/IconCarTire`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CarTire from category Transport`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Commute': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Transport/IconCommute`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Commute from category Transport`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Metro': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Transport/IconMetro`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Metro from category Transport`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Rocket': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Transport/IconRocket`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Rocket from category Transport`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Ship': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Transport/IconShip`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Ship from category Transport`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ShuttleBus': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Transport/IconShuttleBus`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ShuttleBus from category Transport`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Taxi': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Transport/IconTaxi`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Taxi from category Transport`);
        return { default: () => <Skeleton /> };
      })
    ),
		'TowTruck': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Transport/IconTowTruck`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon TowTruck from category Transport`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Trailer': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Transport/IconTrailer`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Trailer from category Transport`);
        return { default: () => <Skeleton /> };
      })
    ),
		'TrainLeft': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Transport/IconTrainLeft`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon TrainLeft from category Transport`);
        return { default: () => <Skeleton /> };
      })
    ),
		'TrainRight': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Transport/IconTrainRight`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon TrainRight from category Transport`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Tram': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Transport/IconTram`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Tram from category Transport`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Transmission': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Transport/IconTransmission`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Transmission from category Transport`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Truck': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Transport/IconTruck`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Truck from category Transport`);
        return { default: () => <Skeleton /> };
      })
    ),
	},
	'TravelProducts': {
		'AirplaneTicket': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/TravelProducts/IconAirplaneTicket`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon AirplaneTicket from category TravelProducts`);
        return { default: () => <Skeleton /> };
      })
    ),
		'BoardingPass': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/TravelProducts/IconBoardingPass`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon BoardingPass from category TravelProducts`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Car': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/TravelProducts/IconCar`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Car from category TravelProducts`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ConfirmationNumber': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/TravelProducts/IconConfirmationNumber`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ConfirmationNumber from category TravelProducts`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Flight': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/TravelProducts/IconFlight`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Flight from category TravelProducts`);
        return { default: () => <Skeleton /> };
      })
    ),
		'FlightHotel': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/TravelProducts/IconFlightHotel`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon FlightHotel from category TravelProducts`);
        return { default: () => <Skeleton /> };
      })
    ),
		'FreeChange': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/TravelProducts/IconFreeChange`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon FreeChange from category TravelProducts`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Hotel': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/TravelProducts/IconHotel`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Hotel from category TravelProducts`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Passport': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/TravelProducts/IconPassport`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Passport from category TravelProducts`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Train': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/TravelProducts/IconTrain`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Train from category TravelProducts`);
        return { default: () => <Skeleton /> };
      })
    ),
		'TravelVisa': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/TravelProducts/IconTravelVisa`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon TravelVisa from category TravelProducts`);
        return { default: () => <Skeleton /> };
      })
    ),
	},
	'UIActions': {
		'Archive': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconArchive`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Archive from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Block': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconBlock`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Block from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'BugReport': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconBugReport`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon BugReport from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Cast': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconCast`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Cast from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CastConnected': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconCastConnected`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CastConnected from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Check': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconCheck`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Check from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CheckArrow': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconCheckArrow`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CheckArrow from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Checkbox': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconCheckbox`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Checkbox from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CheckboxBlank': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconCheckboxBlank`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CheckboxBlank from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CheckboxIndeterminate': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconCheckboxIndeterminate`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CheckboxIndeterminate from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CheckCircle': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconCheckCircle`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CheckCircle from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CheckDouble': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconCheckDouble`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CheckDouble from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CheckProgress': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconCheckProgress`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CheckProgress from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CheckSquare': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconCheckSquare`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CheckSquare from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Clear': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconClear`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Clear from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ClearCircle': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconClearCircle`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ClearCircle from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ClearSquareFilled': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconClearSquareFilled`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ClearSquareFilled from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ClearSquareOutline': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconClearSquareOutline`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ClearSquareOutline from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CloudDownload': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconCloudDownload`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CloudDownload from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CloudUpload': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconCloudUpload`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CloudUpload from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Copy': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconCopy`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Copy from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Create': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconCreate`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Create from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Cut': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconCut`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Cut from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Delete': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconDelete`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Delete from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Download': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconDownload`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Download from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'DownloadOffline': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconDownloadOffline`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon DownloadOffline from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'DragHandle': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconDragHandle`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon DragHandle from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'DragIndicator': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconDragIndicator`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon DragIndicator from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Duplicate': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconDuplicate`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Duplicate from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Edit': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconEdit`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Edit from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Enter': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconEnter`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Enter from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Exit': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconExit`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Exit from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ExitToApp': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconExitToApp`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ExitToApp from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Explore': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconExplore`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Explore from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ExploreOff': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconExploreOff`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ExploreOff from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'EyeOff': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconEyeOff`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon EyeOff from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'EyeOn': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconEyeOn`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon EyeOn from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Favorite': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconFavorite`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Favorite from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'FavoriteOutline': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconFavoriteOutline`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon FavoriteOutline from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'FilterFunnel': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconFilterFunnel`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon FilterFunnel from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'FilterList': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconFilterList`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon FilterList from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'FilterListApplied': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconFilterListApplied`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon FilterListApplied from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'FiltersBig': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconFiltersBig`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon FiltersBig from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'FilterSort': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconFilterSort`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon FilterSort from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'HamburgerMenu': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconHamburgerMenu`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon HamburgerMenu from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Home': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconHome`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Home from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Launch': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconLaunch`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Launch from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Logout': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconLogout`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Logout from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MapZoomIn': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconMapZoomIn`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MapZoomIn from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MapZoomOut': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconMapZoomOut`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MapZoomOut from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Minus': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconMinus`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Minus from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MinusCircle': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconMinusCircle`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MinusCircle from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MinusSquareFilled': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconMinusSquareFilled`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MinusSquareFilled from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MinusSquareOutline': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconMinusSquareOutline`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MinusSquareOutline from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MinusStar': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconMinusStar`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MinusStar from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'More': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconMore`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon More from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MoreCircle': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconMoreCircle`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MoreCircle from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MoreVertical': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconMoreVertical`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MoreVertical from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'MyLocation': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconMyLocation`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon MyLocation from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'OpenInBrowser': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconOpenInBrowser`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon OpenInBrowser from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Paste': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconPaste`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Paste from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Plus': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconPlus`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Plus from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'PlusCircle': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconPlusCircle`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon PlusCircle from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'PlusSquareFilled': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconPlusSquareFilled`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon PlusSquareFilled from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'PlusSquareOutline': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconPlusSquareOutline`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon PlusSquareOutline from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'PlusStar': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconPlusStar`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon PlusStar from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Print': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconPrint`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Print from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'RadioButton': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconRadioButton`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon RadioButton from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'RadioButtonBlank': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconRadioButtonBlank`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon RadioButtonBlank from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Redeem': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconRedeem`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Redeem from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Reorder': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconReorder`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Reorder from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Save': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconSave`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Save from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Search': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconSearch`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Search from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'SearchMore': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconSearchMore`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon SearchMore from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'SearchOff': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconSearchOff`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon SearchOff from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Send': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconSend`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Send from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Settings': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconSettings`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Settings from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'SettingsGears': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconSettingsGears`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon SettingsGears from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Share': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconShare`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Share from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ShareAndroid': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconShareAndroid`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ShareAndroid from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ShareiOs': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconShareiOs`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ShareiOs from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Shutdown': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconShutdown`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Shutdown from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Sort': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconSort`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Sort from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'SortAlphabeticalAsc': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconSortAlphabeticalAsc`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon SortAlphabeticalAsc from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'SortAlphabeticalDes': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconSortAlphabeticalDes`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon SortAlphabeticalDes from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'SortAscending': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconSortAscending`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon SortAscending from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'SortDescending': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconSortDescending`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon SortDescending from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Sorting': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconSorting`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Sorting from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'SortListAscending': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconSortListAscending`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon SortListAscending from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'SortListDescending': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconSortListDescending`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon SortListDescending from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Spark': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconSpark`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Spark from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Speaker': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconSpeaker`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Speaker from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Star': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconStar`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Star from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'StarHalf': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconStarHalf`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon StarHalf from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Sync': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconSync`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Sync from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Thumbsup': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconThumbsup`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Thumbsup from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ToggleOff': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconToggleOff`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ToggleOff from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ToggleOn': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconToggleOn`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ToggleOn from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Undo': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconUndo`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Undo from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Upgrade': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconUpgrade`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Upgrade from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Upload': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconUpload`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Upload from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ViewCarousel': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconViewCarousel`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ViewCarousel from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ViewColumn': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconViewColumn`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ViewColumn from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ViewDashboard': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconViewDashboard`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ViewDashboard from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ViewFeed': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconViewFeed`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ViewFeed from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ViewGrid': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconViewGrid`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ViewGrid from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ViewHeadline': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconViewHeadline`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ViewHeadline from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ViewModule': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconViewModule`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ViewModule from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ViewQuilt': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconViewQuilt`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ViewQuilt from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Wrench': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconWrench`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Wrench from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ZoomIn': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconZoomIn`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ZoomIn from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ZoomOut': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/UIActions/IconZoomOut`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ZoomOut from category UIActions`);
        return { default: () => <Skeleton /> };
      })
    ),
	},
	'User': {
		'Accessibility': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/User/IconAccessibility`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Accessibility from category User`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Baby': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/User/IconBaby`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Baby from category User`);
        return { default: () => <Skeleton /> };
      })
    ),
		'FlexNames': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/User/IconFlexNames`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon FlexNames from category User`);
        return { default: () => <Skeleton /> };
      })
    ),
		'GoupAdd': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/User/IconGoupAdd`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon GoupAdd from category User`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Id': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/User/IconId`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Id from category User`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Lavatory': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/User/IconLavatory`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Lavatory from category User`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Man': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/User/IconMan`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Man from category User`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ManBaggageRunning': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/User/IconManBaggageRunning`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ManBaggageRunning from category User`);
        return { default: () => <Skeleton /> };
      })
    ),
		'ManBaggageWalking': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/User/IconManBaggageWalking`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon ManBaggageWalking from category User`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Passengers': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/User/IconPassengers`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Passengers from category User`);
        return { default: () => <Skeleton /> };
      })
    ),
		'PassengersChild': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/User/IconPassengersChild`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon PassengersChild from category User`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Pax': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/User/IconPax`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Pax from category User`);
        return { default: () => <Skeleton /> };
      })
    ),
		'SupportAgent': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/User/IconSupportAgent`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon SupportAgent from category User`);
        return { default: () => <Skeleton /> };
      })
    ),
		'User': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/User/IconUser`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon User from category User`);
        return { default: () => <Skeleton /> };
      })
    ),
		'UserAccessibility': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/User/IconUserAccessibility`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon UserAccessibility from category User`);
        return { default: () => <Skeleton /> };
      })
    ),
		'UserAdd': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/User/IconUserAdd`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon UserAdd from category User`);
        return { default: () => <Skeleton /> };
      })
    ),
		'UserCard': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/User/IconUserCard`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon UserCard from category User`);
        return { default: () => <Skeleton /> };
      })
    ),
		'UserChange': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/User/IconUserChange`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon UserChange from category User`);
        return { default: () => <Skeleton /> };
      })
    ),
		'UserChecked': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/User/IconUserChecked`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon UserChecked from category User`);
        return { default: () => <Skeleton /> };
      })
    ),
		'UserCommunicate': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/User/IconUserCommunicate`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon UserCommunicate from category User`);
        return { default: () => <Skeleton /> };
      })
    ),
		'UserComplain': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/User/IconUserComplain`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon UserComplain from category User`);
        return { default: () => <Skeleton /> };
      })
    ),
		'UserEdit': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/User/IconUserEdit`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon UserEdit from category User`);
        return { default: () => <Skeleton /> };
      })
    ),
		'UserFind': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/User/IconUserFind`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon UserFind from category User`);
        return { default: () => <Skeleton /> };
      })
    ),
		'UserLocation': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/User/IconUserLocation`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon UserLocation from category User`);
        return { default: () => <Skeleton /> };
      })
    ),
		'UserNoAccount': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/User/IconUserNoAccount`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon UserNoAccount from category User`);
        return { default: () => <Skeleton /> };
      })
    ),
		'UserNonPrime': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/User/IconUserNonPrime`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon UserNonPrime from category User`);
        return { default: () => <Skeleton /> };
      })
    ),
		'UserNotFounded': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/User/IconUserNotFounded`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon UserNotFounded from category User`);
        return { default: () => <Skeleton /> };
      })
    ),
		'UserPregnant': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/User/IconUserPregnant`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon UserPregnant from category User`);
        return { default: () => <Skeleton /> };
      })
    ),
		'UserPrime': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/User/IconUserPrime`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon UserPrime from category User`);
        return { default: () => <Skeleton /> };
      })
    ),
		'UserSettings': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/User/IconUserSettings`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon UserSettings from category User`);
        return { default: () => <Skeleton /> };
      })
    ),
		'UserShield': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/User/IconUserShield`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon UserShield from category User`);
        return { default: () => <Skeleton /> };
      })
    ),
		'UserStar': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/User/IconUserStar`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon UserStar from category User`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Woman': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/User/IconWoman`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Woman from category User`);
        return { default: () => <Skeleton /> };
      })
    ),
	},
	'Weather': {
		'Autumn': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Weather/IconAutumn`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Autumn from category Weather`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Cloud': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Weather/IconCloud`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Cloud from category Weather`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CloudyDay': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Weather/IconCloudyDay`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CloudyDay from category Weather`);
        return { default: () => <Skeleton /> };
      })
    ),
		'CloudyNight': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Weather/IconCloudyNight`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon CloudyNight from category Weather`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Night': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Weather/IconNight`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Night from category Weather`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Rain': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Weather/IconRain`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Rain from category Weather`);
        return { default: () => <Skeleton /> };
      })
    ),
		'SeasonWinter': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Weather/IconSeasonWinter`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon SeasonWinter from category Weather`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Spring': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Weather/IconSpring`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Spring from category Weather`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Storm': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Weather/IconStorm`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Storm from category Weather`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Summer': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Weather/IconSummer`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Summer from category Weather`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Sun': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Weather/IconSun`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Sun from category Weather`);
        return { default: () => <Skeleton /> };
      })
    ),
		'Weather': lazy(() =>
      import(
        /* webpackExclude: /.js.map$/ */ `./content/Weather/IconWeather`
      ).catch(() => {
        // eslint-disable-next-line no-console
        console.warn(`Unable to load icon Weather from category Weather`);
        return { default: () => <Skeleton /> };
      })
    ),
	},
};
